import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";

const route = "MasterImport/";

export default class {

  static uploadSpreadsheetForImport(file, fileName) {

    let url = `${config.uploadUrl + route}UploadSpreadsheetForImport`;

    const { name, headers } = _extractFileHeaders(fileName, file);

    return  http({
      url,
      method: "POST",
      params: { fileName: name },
      data: new Blob([file]),
      headers
    });
  }

  static getAllMasterRules() {
    let url = `${config.uploadUrl + route}GetAllMasterRules`;

    return http({
      url,
      method: "GET",
    });
  }


  static getRulesLinkedToSpreadsheetImport(importStatusId) {

    let url = `${config.uploadUrl + route}GetRulesLinkedToSpreadsheetImport`;

    return http({
      url,
      method: "GET",
      params: { importStatusId },
    });
  }

  static getTagLabelsLinkedToSpreadsheetImport(importStatusId) {

    let url = `${config.uploadUrl + route}GetTagLabelsLinkedToSpreadsheetImport`;

    return http({
      url,
      method: "GET",
      params: { importStatusId },
    });
  }

  static getTagLabelConfiguration(label) {
    let url = `${config.uploadUrl + route}GetTagLabelConfiguration`;

    return http({
      url,
      method: "GET",
      params: { label },
    });
  }

  static async updateTagLabelConfiguration(tagLabelConfig, importStatusId) {
    let url = `${config.uploadUrl + route}UpdateTagLabelConfiguration`;

    return http({
      url,
      method: "POST",
      params: { importStatusId },
      data: tagLabelConfig
    });
  }

  static async applyChildRuleChangesForMasterRule(masterRuleInstanceId) {

    let url = `${config.uploadUrl + route}ApplyChildRuleChangesForMasterRule`;

    return http({
      url,
      method: "POST",
      params: { masterRuleInstanceId },
    });

  }

  static async applyChildRuleChangesForSpreadsheetImport(importStatusId) {

    let url = `${config.uploadUrl + route}ApplyChildRuleChangesForSpreadsheetImport`;

    return http({
      url,
      method: "POST",
      params: { importStatusId },
    });

  }

  static importStatusCodeToText(code) {

    const enumerations = {
      'pending': "Pending",
      'importing': "Importing",
      'config_incomplete': "Configuration Incomplete",
      'complete' : "Complete",
      'failed': "Failed"
    }

    return enumerations[code];

  }

}

function _extractFileHeaders(fileName, file) {
  fileName = fileName || DateTime.parse(new Date(), "hh_mm_ss_DD_MM_YYYY");

  const arr = file.name.split(".");
  const extension = "." + arr[(arr.length || 1) - 1];

  const name = fileName.endsWith(".xlsx")
    ? fileName
    : fileName + extension;

  const headers = {
    'Content-Disposition': 'attachment; filename="' + file.name + '"'
  };
  return { name, headers };
}



// WEBPACK FOOTER //
// ./src/services/masterImport.js